import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, from, NEVER, Observable } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationResult } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { emit } from 'process';

export const BYPASS_JW_TOKEN = new HttpContextToken(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private ngxLoader: NgxUiLoaderService) {}

 /* intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.ngxLoader.start();
    return next.handle(req).pipe(
      finalize(() => this.ngxLoader.stop())
    );
  }*/

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.ngxLoader.start();

   

/*    const reqClone=req.clone({
     
    });

    if (req.context.get(BYPASS_JW_TOKEN) === true) {
      return next.handle(req).pipe(
        finalize(() => this.ngxLoader.stop())
      );
    }
  */
 
    if (req.context.get(BYPASS_JW_TOKEN)) {
      // Modify the request as needed
      const clonedRequest = req.clone({
        // Add any headers or other modifications here
      });

      return next.handle(clonedRequest).pipe(
        finalize(() => this.ngxLoader.stop())
      );
     
    }


      return next.handle(req).pipe(
        finalize(() => this.ngxLoader.stop())
      );
  }

    
}